// ArrayBuffer из другого realm (iframe, тесты в jsdom с TextEncoder из Node) не проходит instanceof
export function isArrayBuffer(value: unknown): value is ArrayBuffer {
  return Object.prototype.toString.call(value) === '[object ArrayBuffer]'
}
